import { createAsyncThunk } from '@reduxjs/toolkit';

import { endpoints } from '../../utils/endpoints';
import { fetchJSON } from '../../utils/fetch';

type GetFetchDetailsEndpoint = (
  key: string,
) => (eventSlug: string, widgetId?: string) => string;

const get = endpoints() as GetFetchDetailsEndpoint;

type EventDetailsParams = {
  eventSlug: string;
  widgetId: string | null;
  code: string | null;
};

const getEventDetailsEndpoint = ({
  eventSlug,
  widgetId,
  code,
}: EventDetailsParams): string => {
  if (widgetId) {
    return get('EVENT_DETAILS_WIDGET')(eventSlug, widgetId);
  }

  const eventDetailsEndpoint = get('EVENT_DETAILS')(eventSlug);
  if (code) {
    return eventDetailsEndpoint + `?code=${code}`;
  }

  return eventDetailsEndpoint;
};

const fetchEventDetails = createAsyncThunk(
  'eventDetails/fetchEventDetails',
  async (params: EventDetailsParams) => {
    const headers = {
      Accept: 'application/json',
    };

    const endpoint = getEventDetailsEndpoint(params);
    return await fetchJSON(endpoint, { headers });
  },
);

export { fetchEventDetails };
